// extracted by mini-css-extract-plugin
export default {"root":"AuthStatus_root__sjyGs","username":"AuthStatus_username__OGCUv"};